import "./Promotions.css";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";
import { useNavigate } from "react-router-dom";
import React, { useMemo, useState } from "react";
import NoData from "../../common/NoData";
import Announcement from "../../common/Announcement";
import useTranslate from "../../hooks/useTranslate";

export default function Promotions({ promotions = [] }) {
  const navigate = useNavigate();
  const { t } = useTranslate();
console.log("adas", promotions);

  const [activeTab, setActiveTab] = useState("all");
  const [loadingDetails, setLoadingDetails] = useState(false);

  const tabs = [
    { key: "all", label: t("all") },
    { key: "sports", label: t("sports") },
    { key: "casino", label: t("casino") },
    { key: "slots", label: t("slots") },
  ];

  const getPromotionCategory = (promotion) => {
    const text = [
      promotion?.category,
      promotion?.type,
      promotion?.promotion_type,
      promotion?.name,
      promotion?.title,
      promotion?.desc,
      promotion?.description,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    if (
      text.includes("sport") ||
      text.includes("cricket") ||
      text.includes("football") ||
      text.includes("exchange")
    ) {
      return "sports";
    }

    if (
      text.includes("casino") ||
      text.includes("live") ||
      text.includes("baccarat") ||
      text.includes("roulette")
    ) {
      return "casino";
    }

    if (
      text.includes("slot") ||
      text.includes("slots") ||
      text.includes("spin") ||
      text.includes("jili") ||
      text.includes("pg")
    ) {
      return "slots";
    }

    return "all";
  };

  const filteredPromotions = useMemo(() => {
    if (activeTab === "all") return promotions;

    return promotions.filter((promotion) => {
      const detected = getPromotionCategory(promotion);
      return detected === activeTab;
    });
  }, [activeTab, promotions]);

  const handleShowModal = async (promotionId) => {
    setLoadingDetails(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/promotions/${promotionId}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch promotion details");
      }

      const promotionDetails = await response.json();

      navigate("/promotions-detail", {
        state: { promotion: promotionDetails },
      });
    } catch (error) {
      console.error("Error fetching promotion details:", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  return (
    <div className="promo-app">
      <Header />

      <div className="promo-page-shell">
        <div className="promo-top-banner">
          <img
            src="../../images/promos.jpg"
            alt={t("promotion")}
            className="promo-top-banner-img"
          />
        </div>

        <Announcement />

        <div className="promo-heading-row">
          <span className="promo-heading-line" />
          <h2>{t("promotion")}</h2>
          <span className="promo-heading-line" />
        </div>

        <div className="promo-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`promo-tab ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="promo-list">
          {filteredPromotions.length > 0 ? (
            filteredPromotions.map((promotion) => (
              <button
                type="button"
                className="promo-image-card"
                key={promotion.id}
                onClick={() => handleShowModal(promotion.id)}
                disabled={loadingDetails}
              >
                <div className="promo-card-title">
                  {promotion?.name || promotion?.title || t("promotion")}
                </div>

                <img
                  src={`${process.env.REACT_APP_API_URL}/storage/${promotion.thumbnail}`}
                  alt={promotion?.name || t("promotion")}
                  loading="lazy"
                  className="promo-banner"
                />
              </button>
            ))
          ) : (
            <NoData />
          )}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}